import React from 'react';
import { connect } from 'react-redux';

import EmptyUser from '../change-user-48.png';
import { addReceiver } from '../../../../actions';

import styles from './UserCard.css';

const mapDispatchToProps = dispatch => {
  return {
    addReceiver: user => dispatch(addReceiver(user))
  };
};

class ConnectedUserCard extends React.Component {

  saveReceiver = () => {
    this.props.addReceiver({
      id: this.props.user.id,
      username: this.props.user.username
    });
  }
  render() {
    let mainContainerTheme = '';
    if (this.props.theme === 'DARK') {
      mainContainerTheme = styles.mainContainerDarkTheme;
    }
    return (
      <div className={[styles.mainContainer, mainContainerTheme].join(' ')} onClick={this.saveReceiver}>
        {this.props.user.photoUrl ?
          <img src={this.props.user.photoUrl} alt='' className={styles.photo} /> :
          <img src={EmptyUser} alt='' className={styles.photo} />
        }
        <div className={styles.infoContainer}>
          <label className={styles.username}>{this.props.user.username}</label>
          <label className={styles.state}>{this.props.user.state}</label>
          {this.props.user.lastDisconnection &&
            <label className={styles.lastTimeSeen}>{'Última conexión: ' + getLastTimeSeenTime(this.props.user)}</label>
          }
        </div>
      </div>
    )
  }
}

const getLastTimeSeenTime = (user) => {
  if (!user.lastDisconnection) {
    return '';
  } else {
    const date = new Date(user.lastDisconnection);
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " " +
      date.getHours() + ":" + date.getMinutes();
  }
}

const UserCard = connect(null, mapDispatchToProps)(ConnectedUserCard);

export default UserCard;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/user-card/UserCard.jsx